import React, { useState} from 'react';
import { AiFillGithub} from "react-icons/ai"
import { motion} from "framer-motion"
import { images } from '../../constants';
import {AppWrap, MotionWrap} from "../../wrapper"
import './Work.scss'

const works = [
  {title: 'Buz@p', link:'https://github.com/Sbieey/Webapp01',description: 'Frontend developer with more than 5 years experience building efficient web applications, interactive and fully responsible for all kind of devices ', imgUrl: images.about01, tags: 'Web App'},
  {title: 'Backend Dev', link:"https://github.com/Sbieey/bussinessPlan", description: 'A backend engineer with 6years experience managing difference kind of application using different kind of languages and software, ', imgUrl: images.about02, tags: 'PHP'},
  {title: 'Web Designer', link:"https://github.com/Sbieey/ChattingAppReact",description: 'This is chat application build using react framework, and integrated with live public API   ', imgUrl: images.about03, tags: 'React JS'},
  {title: 'MERN Stack', link:"https://github.com/Sbieey/movieErra",description: 'A MERN developer and a proficient engineer of all app, with inquisition of learning new stuffs (_an exceptional problem solver.) ', imgUrl: images.about04, tags: 'React JS'},
  {title: 'MERN Stack', link:"https://github.com/Sbieey/reactApp-with-chat",description: 'I am a web designer with passion for creating a functional web applications', imgUrl: images.about05, tags: 'React JS'},
  {title: 'MERN Stack', link:"https://github.com/Sbieey/WebApp03",description: 'A MERN developer and a proficient engineer of all app, with inquisition of learning new stuffs (_an exceptional problem solver.) ', imgUrl: images.about06, tags: 'Web App'},
  {title: 'MERN Stack', link:"https://github.com/Sbieey/WebApp02",description: 'A backToTop using HTML, CSS And JavaScript', imgUrl: images.about07, tags: 'Web App'},
  {title: 'MERN Stack', link:"https://github.com/Sbieey/Buz-p",description: 'A chatting using HTML, CSS, PHP and JQuery  ', imgUrl: images.about08, tags: 'PHP'},
  {title: 'MERN Stack', link:"https://github.com/Sbieey/WebApp04",description: 'Static Web page using HTML AND CSS', imgUrl: images.about09, tags: 'Web App'},
  {title: 'MERN Stack',link:"https://github.com/Sbieey/Auth_tutorial/tree/master", description: 'A full authenticated App using NodeJS framework', imgUrl: images.about10, tags: 'Node JS'}
]

const Work = () => {
    const [activeFilter, setActiveFilter] = useState('All')
    const [animateCard, setAnimateCard] = useState({y: 0, opacity: 1})
    const [filterWork, setFilterWork] = useState(works)

    // setFilterWork(works)
    const handleWorkFilter = (item) => {
        setActiveFilter(item);
        setAnimateCard([{y:100, opacity: 0}]);

        setTimeout(() => {
            setAnimateCard([{y:0, opacity: 1}]);

            if(item === 'All') {
                setFilterWork(works);
            }else{
                setFilterWork(works.filter((work) => work.tags.includes(item)))
            }
        }, 500)
    }

    return(
        <>
         <h2 className='head-text' style={{color:"#ffffff"}}>Porfolio</h2>
        <div className='app__work-filter'>
        {['Web App', 'Node JS','React JS', 'PHP', 'All'].map((item, index) => (
            <div 
            key={index}
            onClick={() => handleWorkFilter(item)}
            className = {`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' :  ''}`}
            >
                {item}
            </div>
        ))}
        </div>
        <motion.div
        animate= {animateCard}
        transition= {{duration:0.5, delayChildren: 0.5}}
        className='app__work-portfolio'
        >
            {filterWork.map((work, index) => (
                <div className='app__work-item app__flex' key= {index}>
                    <div className='app__work-img app__flex'>
                        <img src={work.imgUrl} alt={work.title} />

                        <motion.div
                        whileHover={{opacity: [0,1]}}
                        transition={{duration:0.25, ease: 'easeInOut', staggerChildren: 0}}
                        className='app__work-hover app__flex'
                        >
                          {/* <a href="www.google.com" target="_blank" rel="noreferrer">
                            <motion.div
                            whileInView={{scale: [0, 1]}}
                            whileHover={{scale: [1, 0.9]}}
                            transition={{duration:0.25 }}
                            className='app__flex'
                            >
                                <AiFillEye />
                            </motion.div>
                          </a> */}
                        
                         <a href={work.link} target="_blank" rel="noreferrer">
                            <motion.div
                            whileInView={{scale: [0, 1]}}
                            whileHover={{scale: [1, 0.9]}}
                            transition={{duration:0.25 }}
                            className='app__flex'
                            >
                                <AiFillGithub />
                            </motion.div>
                          </a>
                          </motion.div>
                    </div>

                <div className='app__work-content app__flex'>
                    <h4 className='bold-text'>{work.title}</h4>
                    <p className='p-text' style={{marginTop: 10}}>{work.description}</p>

                    <div className='app__work-tag app__flex'>
                        <p className='p-text'>{work.tags}</p>
                    </div>

                </div>

                </div>
            ))}
        </motion.div>
        </>
    )
}

export default AppWrap(MotionWrap(Work, 'app__work'), 'work')